import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/hr/leave-types";

// Fetch Leave Types
export const fetchLeaveTypes = createAsyncThunk("leaveTypes/fetch", async (_, { rejectWithValue }) => {
  try {
    const response = await hrmsGetRequest(API_URL);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to fetch leave types");
  }
});

// Add Leave Type
export const addLeaveType = createAsyncThunk("leaveTypes/add", async (leaveData, { rejectWithValue }) => {
  try {
    const response = await hrmsPostRequest(API_URL, leaveData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to add leave type");
  }
});

// Update Leave Type
export const updateLeaveType = createAsyncThunk("leaveTypes/update", async ({ id, updatedData }, { rejectWithValue }) => {
  try {
    const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to update leave type");
  }
});

// Delete Leave Type
export const deleteLeaveType = createAsyncThunk("leaveTypes/delete", async (id, { rejectWithValue }) => {
  try {
    await hrmsDeleteRequest(`${API_URL}/${id}`);
    return id;
  } catch (error) {
    return rejectWithValue(error.response?.data?.message || "Failed to delete leave type");
  }
});

const leaveSlice = createSlice({
  name: "leaveTypes",
  initialState: {
    leaveTypes: [],
    status: "idle",
    error: null,
    deleteStatus: "idle",
  },
  reducers: {
    resetDeleteStatus: (state) => {
      state.deleteStatus = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaveTypes.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLeaveTypes.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.leaveTypes = action.payload;
        state.error = null;
      })
      .addCase(fetchLeaveTypes.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(addLeaveType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(addLeaveType.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.leaveTypes.push(action.payload);
        state.error = null;
      })
      .addCase(addLeaveType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(updateLeaveType.pending, (state) => {
        state.status = "loading";
      })
      .addCase(updateLeaveType.fulfilled, (state, action) => {
        state.status = "succeeded";
        const index = state.leaveTypes.findIndex((l) => l.id === action.payload.id);
        if (index !== -1) {
          state.leaveTypes[index] = action.payload;
        }
        state.error = null;
      })
      .addCase(updateLeaveType.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })
      .addCase(deleteLeaveType.pending, (state) => {
        state.deleteStatus = "loading";
      })
      .addCase(deleteLeaveType.fulfilled, (state, action) => {
        state.deleteStatus = "succeeded";
        state.leaveTypes = state.leaveTypes.filter((l) => l.id !== action.payload);
        state.error = null;
      })
      .addCase(deleteLeaveType.rejected, (state, action) => {
        state.deleteStatus = "failed";
        state.error = action.payload;
      });
  },
});

export const { resetDeleteStatus: resetLeaveTypeDeleteStatus } = leaveSlice.actions;
export default leaveSlice.reducer;